var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:_vm.sizeClass,style:(_vm.returnStyles),attrs:{"align-center":"","justify-center":""}},[_c('span',{staticClass:"text-xs-center",class:_vm.showH1 ? 'h1--small' : ''},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }